import { fromJS } from 'immutable';

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  LOGOUT_FORCE,
  LOGOUT_SUCCESS,
  CHECK_AUTHENTICATED,
  CHECK_AUTHENTICATED_SUCCESS,
  CHECK_AUTHENTICATED_FAILURE,
  FORGOT_PW,
  FORGOT_PW_SUCCESS,
  FORGOT_PW_FAILURE,
  VERIFICATION_CODE_ENTERED,
  NEW_PW_ENTERED,
  NEW_PW_ENTERED_SUCCESS,
  NEW_PW_ENTERED_FAILURE,
  LOGIN_CHANGE_SCREEN,
  RESEND_VERIFICATION_EMAIL,
  RESEND_VERIFICATION_EMAIL_SUCCESS,
  RESEND_VERIFICATION_EMAIL_FAILURE,
} from '../actions/actionTypes';

import { LOGIN_SCREENS } from '../../constants';

const initialState = fromJS({
  isAuthenticated: null,
  isLoading: false,
  error: null,
  loginScreen: LOGIN_SCREENS.NORMAL,
  message: null,
  verificationCode: null,
  verificationEmail: null,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return state.set('isLoading', true).set('error', null);
    case LOGIN_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isAuthenticated', true)
        .set('error');
    case LOGIN_FAILURE:
      return state
        .set('isLoading', false)
        .set('error', fromJS({ message: action.errMsg }));
    case CHECK_AUTHENTICATED:
      return state;
    case CHECK_AUTHENTICATED_SUCCESS:
      return state;
    // .set('isLoading', false)
    // .set('isAuthenticated', true)
    // .set('error');
    case CHECK_AUTHENTICATED_FAILURE:
      return state.set('error', fromJS({ message: action.errMsg }));
    case LOGOUT:
      return state.set('isLoading', true).set('error', null);
    case LOGOUT_SUCCESS:
      return state
        .set('isLoading', false)
        .set('isAuthenticated', false)
        .set('error');
    case LOGOUT_FORCE:
      return state
        .set('isLoading', false)
        .set('isAuthenticated', false)
        .set('error');
    // case LOGOUT_FAILURE:
    //   return state
    //     .set('isLoading', false)
    //     .set('error', fromJS({ message: action.errMsg }));
    case FORGOT_PW:
      return state
        .set('isLoading', true)
        .set('error', null)
        .set('verificationEmail', action.credentials.email);
    case FORGOT_PW_SUCCESS:
      return state
        .set('isLoading', false)
        .set('error', null)
        .set('message', action.codeDeliveryDetails);
    case FORGOT_PW_FAILURE:
      return state
        .set('isLoading', false)
        .set('verificationEmail', null)
        .set('error', fromJS({ message: action.errMsg }));
    case VERIFICATION_CODE_ENTERED:
      return state
        .set('error', null)
        .set('verificationCode', action.verificationCode)
        .set('loginScreen', LOGIN_SCREENS.NEW_PASSWORD);
    case NEW_PW_ENTERED:
      return state.set('error', null).set('isLoading', true);
    case NEW_PW_ENTERED_SUCCESS:
      return state.set('isLoading', false).set('error', null);
    case NEW_PW_ENTERED_FAILURE:
      return state
        .set('isLoading', false)
        .set('error', fromJS({ message: action.errMsg }));
    case LOGIN_CHANGE_SCREEN:
      return state.set('loginScreen', action.newScreen);
    case RESEND_VERIFICATION_EMAIL:
      return state.set('isLoading', true).set('error', null);
    case RESEND_VERIFICATION_EMAIL_SUCCESS:
      return state.set('isLoading', false);
    case RESEND_VERIFICATION_EMAIL_FAILURE:
      return state
        .set('isLoading', false)
        .set('error', fromJS({ message: action.errMsg }));
    default:
      return state;
  }
};

export default reducer;
